import React from 'react';

import BlockSuggestion from '@features/blockSuggestion/components/block/BlockSuggestion';

const BlockSection = ({ selectedMeasurementType, fittingResponse, isEditable }) => {
	return (
		<div>
			<section className="similar-styles-section my-3">
				<div className="d-flex w-100">
					<div className="right-half">
						<BlockSuggestion
							fromPage="MEASUREMENT"
							selectedMeasurementType={selectedMeasurementType}
							fittingResponse={fittingResponse}
							isEditable={isEditable}
						/>
					</div>
				</div>
			</section>
		</div>
	);
};

export default BlockSection;
